module.exports = __webpack_public_path__ + "static/girl-af13cdfad993a761e36eb93d3507a3a9.jpg";